import {MutationTree} from 'vuex';
import {ContentBlockInterface, ContentStateInterface, IssueStepInterface} from '@/store/modules/content/types';
import {Vue} from 'vue-property-decorator';

export const mutations: MutationTree<ContentStateInterface> = {
  updateBlocks(state: ContentStateInterface, payload: ContentBlockInterface[]): void {
    Vue.set(state, 'blocks', payload);
  },
  updateSteps(state: ContentStateInterface, payload: IssueStepInterface[]): void {
    Vue.set(state, 'steps', payload);
  },
};
